<div class="lg:mx-[12.5%] md:mx-[8%] mx-[2%] min-[1560px]:flex min-[1560px]:justify-center">
    <div class="max-w-[1200px] w-full py-3">
        <app-view-general-info [data]="generalInfoData" [managerSystem]="managerSystem" [isCM]="isCM"></app-view-general-info>
        <!-- <app-payment-info [data]="paymentInfoData"></app-payment-info> -->
        <!-- <app-contract-info [data]="contractInfoData" [isFormDisabled]="true"></app-contract-info> -->
    </div>
</div>